import { render } from "./FormFeedback.vue?vue&type=template&id=696510dd&ts=true&lang=pug"
import script from "./FormFeedback.vue?vue&type=script&setup=true&lang=ts"
export * from "./FormFeedback.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__